// eslint-disable-next-line
import React, { useState } from 'react';
import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { NavigationType } from '@nal/navigation';
import styles from './NavigationItem.module.scss';
import { Link, useLocation } from 'react-router-dom';
import _ from 'lodash';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronDownIcon from '@material-ui/icons/ExpandMore';
import { State } from 'history';
import { connect } from 'react-redux';

const PADDING_CHILD_STEP = 25;

type NavigationItemPropType = {
    item: NavigationType;
    open: boolean;
    level?: number;
    role?: string;
};

const NavigationItem: React.FC<NavigationItemPropType> = ({ item, open, level, role }) => {
    const [showChild, setShowChild] = useState(false);
    const Icon = item?.icon;
    const LEVEL = level || 0;
    const location = useLocation();
    const highlight = location.pathname === _.get(item, 'path');

    return (
        <>
            {item.type === 'single' && (!item.roles || _.includes(item.roles, role)) && (
                <Link to={item.path} className={`${styles.Link}`}>
                    <ListItem
                        button
                        key={item.id}
                        style={{
                            paddingLeft: LEVEL * PADDING_CHILD_STEP + 16 + 'px',
                        }}
                        className={`${styles.ListItem} ${styles.WithOpen} ${highlight ? styles.HighLight : ''}`}
                    >
                        <ListItemIcon className={styles.ListIcon}>
                            <Icon />
                        </ListItemIcon>
                        {open && <ListItemText className={styles.ListText} primary={item.label} />}
                    </ListItem>
                </Link>
            )}
            {item.type === 'group' && (!item.roles || _.includes(item.roles, role)) && (
                <>
                    <ListItem
                        button
                        key={item.id}
                        style={{
                            paddingLeft: LEVEL * PADDING_CHILD_STEP + 16 + 'px',
                        }}
                        className={`${styles.ListItem} ${styles.WithOpen} ${styles.HasChildList} ${
                            highlight ? styles.HighLight : ''
                        }`}
                        onClick={() => setShowChild(!showChild)}
                    >
                        <ListItemIcon className={styles.ListIcon}>
                            <Icon />
                        </ListItemIcon>
                        {open && <ListItemText className={styles.ListText} primary={item.label} />}
                        {open && (
                            <ListItemIcon className={styles.ShowChildIcon}>
                                {showChild ? <ChevronDownIcon /> : <ChevronRightIcon />}
                            </ListItemIcon>
                        )}
                    </ListItem>
                    {open &&
                        showChild &&
                        item.children &&
                        item.children.map((children) => (
                            <NavigationItem level={LEVEL + 1} open={open} item={children} key={children.id} />
                        ))}
                </>
            )}
        </>
    );
};

function mapStateToProps(state: State) {
    return {
        role: _.get(state, 'Me.role'),
    };
}

export default connect(mapStateToProps)(NavigationItem);
